// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkout_wrapper__1Rm-8","title":"Checkout_title__1HSXm"};